// Constantes métier GLPI : libellés FR pour les codes numériques.
// Permet d'éviter de dispatcher des "magic numbers" dans l'UI.

import { TaskState, TicketStatus, TicketType } from "./glpi";

export const TICKET_TYPE_LABELS: Record<TicketType, string> = {
  1: "Incident",
  2: "Demande",
};

export const TICKET_STATUS_LABELS: Record<TicketStatus, string> = {
  1: "Nouveau",
  2: "En cours (attribué)",
  3: "En cours (planifié)",
  4: "En attente",
  5: "Résolu",
  6: "Clos",
};

export const TICKET_STATUS_SHORT: Record<TicketStatus, string> = {
  1: "Nouveau",
  2: "Attribué",
  3: "Planifié",
  4: "En attente",
  5: "Résolu",
  6: "Clos",
};

export const TASK_STATE_LABELS: Record<TaskState, string> = {
  0: "Aucun",
  1: "À faire",
  2: "Fait",
};

/**
 * Libellé générique de la tâche créée automatiquement avec un ticket,
 * en fonction du type de ticket.
 */
export function genericTaskLabel(type: TicketType): string {
  return type === 1 ? "Traitement de l'incident" : "Traitement de la demande";
}

/**
 * Construit l'URL web GLPI d'un ticket à partir de l'URL de l'API REST.
 * Ex. https://glpi.jgv.local/apirest.php -> https://glpi.jgv.local/front/ticket.form.php?id=1234
 */
export function buildTicketWebUrl(apiUrl: string, ticketId: number): string {
  const base = apiUrl.replace(/\/apirest\.php\/?$/i, "").replace(/\/$/, "");
  return `${base}/front/ticket.form.php?id=${ticketId}`;
}
